import 'css-chunksrc/feature/notification/S2PCheckPaidToastNotification.module.scss';export default {
  "root": "S2PCheckPaidToastNotification_root"
};